module.exports = __webpack_public_path__ + "static/media/petCarrier.09351f57.svg";